import {
  FleetWarehouse,
  FleetWarehouseEditFormValues,
  FleetWarehouseRow,
} from "./types";

export const transformFleetWarehouseRow = (res: any): FleetWarehouseRow => {
  return {
    id: res.id,
    image: res.image,
    name: res.name,
    addressCity: res.addressCity,
    addressCountry: res.addressCountry,
    addressLine1: res.addressLine1,
    addressLine2: res.addressLine2,
    addressPostalCode: res.addressPostalCode,
    addressState: res.addressState,
    addressLatitude: res.addressLatitude,
    addressLongitude: res.addressLongitude,
    contacts: res.contacts,
  };
};

/*---------------------------------------------------------------------------------------
      VEHICLE CATEGORY CREATE/EDIT
  -----------------------------------------------------------------------------------------*/

export const transformFleetWarehouseOnCreate = (
  formValues: FleetWarehouseEditFormValues
): any => ({
  name: formValues.name,
  addressCity: formValues.addressCity,
  addressCountry: formValues.addressCountry,
  addressLine1: formValues.addressLine1,
  addressLine2: formValues.addressLine2,
  addressPostalCode: formValues.addressPostalCode,
  addressState: formValues.addressState,
  addressLatitude: formValues.addressLatitude,
  addressLongitude: formValues.addressLongitude,
  contactIds: formValues.contacts?.map((contact) => contact.id) ?? [],
});

export const transformFleetWarehouseOnUpdate = (
  formValues: FleetWarehouseEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
  addressCity: formValues.addressCity,
  addressCountry: formValues.addressCountry,
  addressLine1: formValues.addressLine1,
  addressLine2: formValues.addressLine2,
  addressPostalCode: formValues.addressPostalCode,
  addressState: formValues.addressState,
  addressLatitude: formValues.addressLatitude,
  addressLongitude: formValues.addressLongitude,
  contactIds: formValues.contacts?.map((contact) => contact.id) ?? [],
});

export const transformFleetWarehouse = (res: any): FleetWarehouse => {

  return {
    id: res.id,
    image: res.image,
    name: res.name,
    addressCity: res.addressCity,
    addressCountry: res.addressCountry,
    addressLine1: res.addressLine1,
    addressLine2: res.addressLine2,
    addressPostalCode: res.addressPostalCode,
    addressState: res.addressState,
    addressLatitude: res.addressLatitude,
    addressLongitude: res.addressLongitude,
    contacts: res.contacts,
  };
};


